@if (image()) {
  <app-images-form
    [edit]="false"
    [create]="false"
    [delete]="true"
    [details]="true"
    [access]="access()"
    [value]="image()"
  ></app-images-form>
}
